module.exports = __webpack_public_path__ + "static/media/baloon2.366ce13b.png";